import axios, { AxiosResponse, AxiosError } from "axios";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export const getTripsOrdersReport = (
    from_date: string,
    to_date: string,
    vehicle_number: string,
    page_number: number,
    per_page_records: number,
    format: string,
    _successCallBack: (response: any) => void,
    _errorCallBack: (errMessage: any) => void,
    warehouse_name?: string,
    client_name?: string
) => {
    const userDetailsFromStorage = JSON.parse(localStorage.getItem("userdetails") || "null");
    const headers = {
        Authorization: `Bearer ${userDetailsFromStorage.token}`,
    };

    const config: any = {
        headers: headers,
        responseType: format ? 'blob' : 'json'
    };

    axios
        .get(`${global.api_url}/api/trips_orders_report?from_date=${from_date}&to_date=${to_date}&vehicle_number=${vehicle_number}&warehouse_name=${warehouse_name}&client_name=${client_name}&page_number=${page_number}&per_page_records=${per_page_records}&format=${format}`, config)
        .then((response: AxiosResponse) => {
            if (response.status === 200 || response.status === 201) {
                _successCallBack(response.data);
            } else {
                _errorCallBack("Unexpected status code: " + response.status);
            }
        })
        .catch((error: AxiosError) => {
            console.log('Error caught:', error); 
            if (error.response?.status === 400 || error.response?.status === 500) {
                _errorCallBack(error.response.data);
            } else if (error.response?.status === 404) {
                console.log(error.response.data);
                _errorCallBack(error.response.data);
            } else if (error.response?.status === 401) {
                localStorage.clear();
            }
        });
};

export const getVehicleUsageReport = (
    from_date: string,
    to_date: string,
    vehicle_number: string,
    page_number: number,
    per_page_records: number,
    format: string,
    _successCallBack: (response: any) => void,
    _errorCallBack: (errMessage: any) => void,
    warehouse_name?: string,
    client_name?: string
) => {
    const userDetailsFromStorage = JSON.parse(localStorage.getItem("userdetails") || "null");
    const headers = {
        Authorization: `Bearer ${userDetailsFromStorage.token}`,
    };

    const config: any = {
        headers: headers,
        responseType: format ? 'blob' : 'json' 
    };

    axios
        .get(`${global.api_url}/api/vehicle_usage_report?from_date=${from_date}&to_date=${to_date}&vehicle_number=${vehicle_number}&warehouse_name=${warehouse_name}&client_name=${client_name}&page_number=${page_number}&per_page_records=${per_page_records}&format=${format}`, config)
        .then((response: AxiosResponse) => {
            if (response.status === 200 || response.status === 201) {
                _successCallBack(response.data);
            } else {
                _errorCallBack("Unexpected status code: " + response.status);
            }
        })
        .catch((error: AxiosError) => {
            console.log('Error caught:', error);
            if (error.response?.status === 400 || error.response?.status === 500) {
                _errorCallBack(error.response.data);
            } else if (error.response?.status === 404) {
                console.log(error.response.data);
                _errorCallBack(error.response.data);
            } else if (error.response?.status === 401) {
                localStorage.clear();
            }
        });
};

export const getClients = (
    _successCallBack: (response: any) => void,
    _errorCallBack: (errMessage: any) => void,
) => {
    const userDetailsFromStorage = JSON.parse(localStorage.getItem("userdetails") || "null");
    const headers = {
        Authorization: `Bearer ${userDetailsFromStorage.token}`
    };
    axios
        .get(`${global.api_url}/api/clients_vendors_mapping`, {
            headers: headers,
        })
        .then((response: AxiosResponse) => {
            if (response.status === 200) {
                _successCallBack(response.data);
            }
            else if (response.status === 201) {
                _successCallBack(response.data);
            }
        })
        .catch((error: AxiosError) => {
            if (error.response?.status === 400) {
                _errorCallBack(error.response.data);
            }
            else if (error.response?.status === 401) {
                localStorage.clear();
            }
            else if (error.response?.status === 404) {
                _errorCallBack(error.response.data);
            }
            else {
                toast.error("Server Error");
            }
        }
        );
};

export const getWarehouses = (
    _successCallBack: (response: any) => void,
    _errorCallBack: (errMessage: any) => void,
) => {
    const userDetailsFromStorage = JSON.parse(localStorage.getItem("userdetails") || "null");
    const headers = {
        Authorization: `Bearer ${userDetailsFromStorage.token}`
    };
    axios
        .get(`${global.api_url}/api/warehouses`, {
            headers: headers,
        })
        .then((response: AxiosResponse) => {
            if (response.status === 200) {
                _successCallBack(response.data);
            }
        })
        .catch((error: AxiosError) => {
            console.log('Error caught:', error);
            if (error.response?.status === 400) {
                _errorCallBack(error.response.data);
            }
            else if (error.response?.status === 401) {
                localStorage.clear();
            }
            else {
                toast.error("Server Error");
            }
        });
};
export const getStoppageReport = (
    from_date: string,
    to_date: string,
    vehicle_number: string,
    page_number: number,
    per_page_records: number,
    format: string,
    _successCallBack: (response: any) => void,
    _errorCallBack: (errMessage: any) => void,
) => {
    const userDetailsFromStorage = JSON.parse(localStorage.getItem("userdetails") || "null");
    const headers = {
        Authorization: `Bearer ${userDetailsFromStorage.token}`,
    };

    const config: any = {
        headers: headers,
        responseType: format ? 'blob' : 'json'
    };

    axios
        .get(`${global.api_url}/api/vehicle_stops_report?from_date=${from_date}&to_date=${to_date}&vehicle_number=${vehicle_number}&per_page_records=${per_page_records}&page_number=${page_number}&format=${format}`, config)
        .then((response: AxiosResponse) => {
            if (response.status === 200 || response.status === 201) {
                _successCallBack(response.data);
            } else {
                _errorCallBack("Unexpected status code: " + response.status);
            }
        })
        .catch((error: AxiosError) => {
            console.log('Error caught:', error); 
            if (error.response?.status === 400 || error.response?.status === 500) {
                _errorCallBack(error.response.data);
            } else if (error.response?.status === 404) {
                console.log(error.response.data);
                _errorCallBack(error.response.data);
            } else if (error.response?.status === 401) {
                localStorage.clear();
            }
        });
};
export const getSpeedReport = (
    from_date: string,
    to_date: string,
    vehicle_number: string,
    page_number: number,
    per_page_records: number,
    mode: string,
    format: string,
    _successCallBack: (response: any) => void,
    _errorCallBack: (errMessage: any) => void,
) => {
    const userDetailsFromStorage = JSON.parse(localStorage.getItem("userdetails") || "null");
    const headers = {
        Authorization: `Bearer ${userDetailsFromStorage.token}`,
    };

    const config: any = {
        headers: headers,
        responseType: format ? 'blob' : 'json'
    };

    axios
        .get(`${global.api_url}/api/vehicle_speed_report?from_date=${from_date}&to_date=${to_date}&vehicle_number=${vehicle_number}&per_page_records=${per_page_records}&page_number=${page_number}&format=${format}&mode=${mode}`, config)
        .then((response: AxiosResponse) => {
            if (response.status === 200 || response.status === 201) {
                _successCallBack(response.data);
            } else {
                _errorCallBack("Unexpected status code: " + response.status);
            }
        })
        .catch((error: AxiosError) => {
            console.log('Error caught:', error); 
            if (error.response?.status === 400 || error.response?.status === 500) {
                _errorCallBack(error.response.data);
            } else if (error.response?.status === 404) {
                console.log(error.response.data);
                _errorCallBack(error.response.data);
            } else if (error.response?.status === 401) {
                localStorage.clear();
            }
        });
};